import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ExpenseTypeConfiguration } from 'on-shared/_models/ExpenseTypeConfiguration';
import { CompanyAction } from 'on-shared/stores/company/company.action';
import { CompanyState } from 'on-shared/stores/company/company.state';
import { TranslateService } from '@ngx-translate/core';
import { ExpenseType } from 'on-shared/_models/ExpenseType';

@Component({
    selector: 'on-expense-types-tab',
    templateUrl: './expense-types-tab.component.html',
    styleUrls: ['./expense-types-tab.component.scss'],
})
export class ExpenseTypesTabComponent implements OnInit, OnDestroy {
    @Input() companyId: number;

    @Select(CompanyState.expenseTypeConfigurations)
    expenseTypeConfigurations$: Observable<ExpenseTypeConfiguration[]>;

    expenseTypeConfigurations: {
        type: ExpenseType;
        customName: string;
        description: string;
        isHidden: boolean;
    }[] = [];
    destroy$ = new Subject<void>();

    expenseTypes: ExpenseTypeConfiguration[] = [];
    isLoading = true;

    constructor(
        private store: Store,
        private translateService: TranslateService,
    ) {}

    ngOnInit() {
        this.isLoading = true;
        this.expenseTypeConfigurations$
            .pipe(takeUntil(this.destroy$))
            .subscribe((expenseTypeConfigurations) => {
                if (expenseTypeConfigurations !== null) {
                    this.expenseTypeConfigurations =
                        expenseTypeConfigurations.map((c) => ({
                            type: c.ExpenseType,
                            customName: c.CustomName,
                            description: c.Description,
                            isHidden: c.IsHidden,
                        }));
                    this.expenseTypeConfigurations.sort((c1, c2) =>
                        this.translateService
                            .instant('db.expense-types.' + c1.type.Code)
                            .localeCompare(
                                this.translateService.instant(
                                    'db.expense-types.' + c2.type.Code,
                                ),
                            ),
                    );
                    this.isLoading = false;
                }
            });

        // Ensure expense type configurations are loaded if needed
        this.store.dispatch(new CompanyAction.LoadExpenseTypeConfigurations());
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onSave() {
        this.store.dispatch(
            new CompanyAction.SaveExpenseTypeConfigurations(
                this.expenseTypeConfigurations.map(
                    (c) =>
                        new ExpenseTypeConfiguration({
                            CustomName: c.customName,
                            Description: c.description,
                            ExpenseTypeId: c.type.Id,
                            ExpenseType: c.type,
                            IsHidden: c.isHidden,
                            Id: c.type.Id,
                        }),
                ),
            ),
        );
    }

    reload() {
        this.store.dispatch(new CompanyAction.LoadExpenseTypeConfigurations());
    }
}
